export default () => (
  <div className="low-cost-search-title-container">
    <div className="low-cost-search-title-line" />
  </div>
);
